export default __webpack_public_path__ + "static/charlycares-eb29200d56f16042f772715b5fd1ff41.png";